var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"quiz container"},[_vm._v("\n    수정 후 '엔터키'를 눌러서 '저장' 버튼을 활성화 하세요.\n    "),_c('editable-quizzes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }